import { ButtonLink } from '@asgard/ui-library';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { CustomersItem } from '../../CompaniesComponent.types';
import {
  StyleAll,
  StyledLogoItem,
  StyledLogos,
  StyledMore,
  StyledTitle,
  StyledWrapper
} from './Customers.styled';

type ContentProps = {
  customers: CustomersItem[];
};

const Customers: React.FC<ContentProps> = ({ customers }) => {
  const { t } = useI18n('companies2');
  const { locale } = useRouter();

  const filteredRow = (e: number): CustomersItem[] => {
    return customers.filter((el: CustomersItem) => {
      if (el.attributes.row === e) {
        return el;
      }
    });
  };

  return (
    <StyledWrapper>
      <StyledTitle>{t('companies.customers.title')}</StyledTitle>

      <StyledLogos>
        <div>
          {filteredRow(1)
            .sort(
              (a, b) => a.attributes.orderInTheRow - b.attributes.orderInTheRow
            )
            .map((item, index) => (
              <StyledLogoItem key={index}>
                <img
                  src={item.attributes.logo.data.attributes.url}
                  alt={item.attributes.companyName}
                />
              </StyledLogoItem>
            ))}
          {filteredRow(1)
            .sort(
              (a, b) => a.attributes.orderInTheRow - b.attributes.orderInTheRow
            )
            .map((item, index) => (
              <StyledLogoItem key={index}>
                <img
                  src={item.attributes.logo.data.attributes.url}
                  alt={item.attributes.companyName}
                />
              </StyledLogoItem>
            ))}
        </div>
      </StyledLogos>
      <StyledLogos className="reverse">
        <div>
          {filteredRow(2)
            .sort(
              (a, b) => a.attributes.orderInTheRow - b.attributes.orderInTheRow
            )
            .map((item, index) => (
              <StyledLogoItem key={index}>
                <img
                  src={item.attributes.logo.data.attributes.url}
                  alt={item.attributes.companyName}
                />
              </StyledLogoItem>
            ))}
          {filteredRow(2)
            .sort(
              (a, b) => a.attributes.orderInTheRow - b.attributes.orderInTheRow
            )
            .map((item, index) => (
              <StyledLogoItem key={index}>
                <img
                  src={item.attributes.logo.data.attributes.url}
                  alt={item.attributes.companyName}
                />
              </StyledLogoItem>
            ))}
        </div>
      </StyledLogos>
      <StyledMore>{t('companies.customers.more')}</StyledMore>

      <StyleAll>
        <ButtonLink
          href={`${getAppUrl(APP_URLS.jobOffers, locale)}?onlyActive=false`}
          target="_blank"
          startIcon={faMagnifyingGlass}
          label={t('companies.customers.all')}
          schema="brand1"
          variant="hard"
        />
      </StyleAll>
    </StyledWrapper>
  );
};

export default Customers;
